module.exports = __webpack_public_path__ + "static/media/shares-investments-other.de608e65.svg";